import { render, staticRenderFns } from "./Ceshi.vue?vue&type=template&id=626f86b2&scoped=true&"
import script from "./Ceshi.vue?vue&type=script&lang=js&"
export * from "./Ceshi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626f86b2",
  null
  
)

export default component.exports